class ShoppingCartTotals {
  constructor(node) {
    this.element = node;
    this.cartTotal = this.element.querySelector(".js-cart-total");
    this.shoppingCartIcon = this.element.querySelector(".js-shopping-cart-icon");

    this.initialize();
  }

  initialize() {
    this.updateIcon();

    window.addEventListener("cart-updated", (e) => {
      const total = parseInt(e.detail.totalAmountOfProducts || e.detail);

      this.checkIfTotalElementExists();
      this.updateIcon(total);

      if (total == 0 || isNaN(total)) {
        this.cartTotal.remove();
        this.cartTotal = null;
        return;
      }

      this.cartTotal.textContent = total;
      this.cartTotal.dataset.quantity = total;
    });
  }

  updateIcon(total = null) {
    if (this.cartTotal === null) {
      return;
    }

    let currentQuantity;

    if (total == null) {
      currentQuantity = parseInt(this.cartTotal.dataset.quantity);
    } else {
      currentQuantity = total;
    }

    if (isNaN(currentQuantity)) {
      return;
    }

    // Faster than switch case
    if (currentQuantity < 25) {
      this.shoppingCartIcon.classList.add("icon-shopping-cart");
      this.shoppingCartIcon.classList.remove("icon-delivered", "icon-truck");
    } else if (currentQuantity < 50) {
      this.shoppingCartIcon.classList.add("icon-delivered");
      this.shoppingCartIcon.classList.remove("icon-shopping-cart", "icon-truck");
    } else {
      this.shoppingCartIcon.classList.add("icon-truck");
      this.shoppingCartIcon.classList.remove("icon-shopping-cart", "icon-delivered");
    }
  }

  checkIfTotalElementExists() {
    if (this.cartTotal === null) {
      this.cartTotal = document.createElement("div");
      this.cartTotal.className = "quantity js-cart-total";
      this.element.appendChild(this.cartTotal);
    }
  }
}

const shoppingCartTotalElements = document.querySelectorAll("[data-js='shopping-cart-totals']");

shoppingCartTotalElements.forEach((element) => {
  new ShoppingCartTotals(element);
});
